/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Avatar,
  DatePicker,
  Input,
  Modal,
  Select,
  Tooltip,
  Upload,
} from 'antd';
import { useChangeHandler } from '@/hooks';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { regexDescription, regexInput } from 'utils/regex';
import {
  createFloor,
  fetchFloor,
  modifyFloor,
  setFloor,
} from 'state/actions/floor';
import { imgUrl } from 'utils/url';
import { log } from 'utils';

import {
  createCategory,
  fetchCategories,
  modifyCategory,
  setCategory,
} from 'state/actions/categories';
import moment from 'moment';
import { ExportIcon } from 'assets/icon/dynamic';
import CategoryDropdown from 'components/CategoryDropdown';
import ModalCategoryForm from 'components/ModalCategoryForm';
import ModalFloorForm from 'components/ModalFloorForm';
import { fetchTags } from 'state/actions/tag';
import { Option } from 'antd/lib/mentions';
import dayjs from 'dayjs';
import _ from 'underscore';
import './ProductForm.css';
import './ProductForm.scss';
import DropdownWrapper from '../DropdownWrapper';
import { poisCleanUpForm } from '../../state/actions/pois';
import { filterAccess } from '../Report/utils';
import { fetchProductCategories } from 'state/actions/productCategories';
import { createProduct, modifyProduct } from 'state/actions/product';

const ProductForm = ({
  product,
  setProduct,
  action,
  success,
  history,
  id,
  error,
}) => {
  const { siteId, productId } = useParams();
  log(error);

  const [isDragged, setIsDragged] = useState(false);
  const [errors, setErrors] = useState(error);
  const [tempSelectedCategory, setTempSelectedCategory] = useState();
  const [tempSelectedCategories, setTempSelectedCategories] = useState([]);
  const [modalCategory, setModalCategory] = useState(false);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [tempSelectedFloor, setTempSelectedFloor] = useState();
  const [tempSelectedFloors, setTempSelectedFloors] = useState([]);
  const [modalFloor, setModalFloor] = useState(false);
  const [floorOpen, setFloorOpen] = useState(false);
  const [firstList, setFirstList] = useState([]);
  const [secondList, setSecondList] = useState([]);
  const [previewList, setPreviewList] = useState([]);
  const [secondPreviewList, setSecondPreviewList] = useState([]);
  const [previewImage, setPreviewImage] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewTitle, setPreviewTitle] = useState('');
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    setErrors(error);
  }, [error]);

  const {
    loading,
    userData,
    siteList,
    categoriesList,
    subCategoryList,
    floorList,
    category,
    tagList,
    shapeList,
    model3dList,
    floor,
    productCategory,
    productSubCategory,
  } = useSelector(
    (state) => ({
      loading: state.pois.loading,
      userData: state.auth.userData,
      siteList: state.sites.list,
      categoriesList: state.categories.list,
      subCategoryList: state.subcategories.list,
      floorList: state.floor.list,
      tagList: state.tags.list,
      shapeList: state.editors.shapeList,
      model3dList: state.editors.model3dList,
      category: state.categories.category,
      floor: state.floor.floor,
      productCategory: state.productCategory.list,
      productSubCategory: state.productCategory.listSubCategory,
    }),
    shallowEqual
  );

  const site = siteList?.find((site) => site._id === siteId);

  const uid = userData.id;

  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(poisCleanUpForm());
  }, [dispatch]);

  useEffect(() => {
    // fetch floor and poi categories
    dispatch(fetchProductCategories({ siteId }));
    dispatch(fetchTags({ siteId }));
  }, [siteId]); // eslint-disable-line

  useEffect(() => {
    if (product) {
      log(product, 'products 123 di product form');
      setTempSelectedCategories(
        product.categoryIds &&
          product.categoryIds.length === 0 &&
          product.categoryId
          ? [product.categoryId]
          : product.categoryIds
      );

      // Initialize tempSelectedFloors based on whether site supports multiple floors
      if (site?.canHaveMultipleFloor) {
        // For multiple floor mode, use floorIds or convert floorId to array
        const floors =
          product.floorIds || (product.floorId ? [product.floorId] : []);
        setTempSelectedFloors(floors);
      } else {
        // For single floor mode, just set the single floor
        setTempSelectedFloors(product.floorId ? [product.floorId] : []);
      }

      if (
        product.categoryIds &&
        product.categoryIds.length === 0 &&
        product.categoryId
      ) {
        setProduct({
          ...product,
          categoryIds: [product.categoryId],
        });
      }

      // Convert between single and multiple floor formats if needed
      if (site?.canHaveMultipleFloor && product.floorId && !product.floorIds) {
        // Site supports multiple floors but POI only has floorId - convert it
        const floorName = floorList.find(
          (f) => f._id === product.floorId
        )?.name;
        setProduct({
          ...product,
          floorIds: [product.floorId],
          floorNames: floorName ? [floorName] : [],
        });
      } else if (
        !site?.canHaveMultipleFloor &&
        product.floorIds &&
        !product.floorId
      ) {
        // Site doesn't support multiple floors but POI has floorIds - convert to single
        setProduct({
          ...product,
          floorId: product.floorIds[0],
          floorName: floorList.find((f) => f._id === product.floorIds[0])?.name,
        });
      }
      if (product.firstMedias && product.secondMedias) {
        if (product.firstMedias && !updated) {
          const images = product.firstMedias.map((image, i) => ({
            uid: `first-${i}`,
            name: image,
            status: 'done',
            url: `${imgUrl}/products/${image}`,
          }));

          setPreviewList(images);

          // 🔥 penting: sync ke product state
          setProduct((prev) => ({
            ...prev,
            firstFileList: images,
          }));
        }

        if (product.secondMedias && !updated) {
          const images = product.secondMedias.map((image, i) => ({
            uid: `second-${i}`,
            name: image,
            status: 'done',
            url: `${imgUrl}/products/${image}`,
          }));

          setSecondPreviewList(images);

          setProduct((prev) => ({
            ...prev,
            secondFileList: images,
          }));
        }

        setUpdated(true);
      }
    }
    // eslint-disable-next-line
  }, [product, site, floorList]);

  const onChangeHandler = useChangeHandler(setProduct);

  const onFileChangedHandler = (file) => {
    setProduct((prevState) => ({ ...prevState, file, logoUrl: null }));
  };

  const handleDeletePreviewImage = () => {
    setProduct((prevState) => ({
      ...prevState,
      file: null,
      logoUrl: null,
      logo: null,
    }));
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();

    if (!product.name) {
      return setErrors({
        message: 'Product name is required',
        errors: {
          name: [{ msg: 'Product name is required' }],
        },
      });
    }

    // optional validation
    if (product.quantity && isNaN(product.quantity)) {
      return setErrors({
        message: 'Quantity must be a number',
        errors: {
          quantity: [{ msg: 'Quantity must be a number' }],
        },
      });
    }
    dispatch(
      productId
        ? modifyProduct(
            productId,
            {
              name: product.name,
              description: product.description || '',

              categoryIds: product.categoryIds || [],
              subCategoryIds: product.subCategoryIds || [],
              tags: product.tags || [],

              quantity: Number(product.quantity) || 0,
              availability:
                product.availability === true ||
                product.availability === 'true',

              file: product.file,
              firstFileList: product.firstFileList,
              secondFileList: product.secondFileList,

              start: product.start ? moment(product.start).format() : null,
              end: product.end ? moment(product.end).format() : null,

              userId: userData.id,

              siteId,
            },
            () => history.goBack()
          )
        : createProduct(
            {
              name: product.name,
              description: product.description || '',

              categoryIds: product.categoryIds || [],
              subCategoryIds: product.subCategoryIds || [],
              tags: product.tags || [],

              quantity: Number(product.quantity) || 0,
              availability:
                product.availability === true ||
                product.availability === 'true',

              file: product.file,
              firstFileList: product.firstFileList,
              secondFileList: product.secondFileList,

              start: product.start ? moment(product.start).format() : null,
              end: product.end ? moment(product.end).format() : null,

              userId: userData.id,

              siteId,
            },
            () => history.goBack()
          )
    );
  };

  const onSelectCategoryHandler = () => {
    // const categoryId = value.value;
    // const categoryName = value.label;
    setProduct((prevState) => ({
      ...prevState,
      categoryId: tempSelectedCategory,
      categoryName: categoriesList.find(
        (cat) => cat._id === tempSelectedCategory
      )?.name,
      categoryIds: [tempSelectedCategory],
    }));
    setPlaylistOpen(false);
  };

  // const canSubmit = product.name && product.description;

  const imagePreviewUrl = product.file
    ? product.file && URL.createObjectURL(product.file)
    : product.logo && `${imgUrl}/products/${product.logo}`;

  // const goBackMessage = useFormatMessage('ProductForm.goBack');

  // const pickAnotherFileMessage = useFormatMessage('ProductForm.pickAnotherFile');
  // const pickFileMessage = useFormatMessage('ProductForm.pickFile');

  const handleChangeDate = ([start, end]) => {
    setProduct({
      ...product,
      start: start ? start.format() : null,
      end: end ? end.format() : null,
    });
  };

  const getCategory = (categoryId) => {
    const findCategory = productCategory.find((cat) => cat._id === categoryId);
    return findCategory?.name;
  };

  const handleNew = () => {
    dispatch(
      setCategory(
        {
          _id: '',
          name: '',
          description: '',
          siteId: '',
          modifiedAt: new Date().toDateString(),
          modifiedBy: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  const onSubmitCategory = () => {
    const action = category._id ? modifyCategory : createCategory;

    dispatch(
      action({ ...category, siteId, id: category._id, uid }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setCategory(data));
  };

  const onSubmitFloor = () => {
    const action = floor._id ? modifyFloor : createFloor;

    dispatch(
      action({ uid, ...floor, siteId, id: floor._id }, () =>
        setModalFloor(false)
      )
    );
  };

  const handleSetFloor = (data) => {
    dispatch(setFloor(data));
  };

  const onFileListChangedHandler = ({ file, params, setList, list }) => {
    setList([...list, file]);
    setProduct((prevState) => ({ ...prevState, [params]: [...list, file] }));
  };

  const handleChange = ({ fileList, setPreview }) => {
    const updatedFile = fileList.map((fileRaw) => {
      const f = { ...fileRaw };
      if (f.status !== 'uploading') {
        f.status = 'done';
      }
      f.response = f.name;
      return f;
    });
    setPreview(updatedFile);
  };

  const handlePreview = async (f) => {
    const file = { ...f };
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    );
  };

  const handleRemove = ({ e, params, productParams, setList, list }) => {
    const images =
      product[productParams] &&
      product[productParams].filter((image) => image !== e.name);
    const fImages = list.filter((f) => f.uid !== e.uid);
    setList(fImages);
    setProduct((prevState) => ({
      ...prevState,
      [productParams]: images,
      [params]: fImages,
    }));
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);

      reader.onerror = (err) => reject(err);
    });

  const handleCancel = () => setPreviewVisible(false);

  return (
    <div className="poi-form">
      <ModalCategoryForm
        visible={modalCategory}
        onCancel={() => setModalCategory(false)}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={!!category._id}
      />
      <ModalFloorForm
        visible={modalFloor}
        onCancel={() => {
          setModalFloor(false);
        }}
        onCreate={onSubmitFloor}
        floor={floor}
        setFloor={handleSetFloor}
        isEditing={!!floor._id}
      />
      <form className="form-wrapper">
        <div>
          <div className="form">
            <label className="form-label">
              Name <span className="is-required">*</span>
            </label>
            <Input
              placeholder="POI Name"
              className={`${
                errors && errors.errors && errors.errors.name ? 'has-error' : ''
              }`}
              name="name"
              value={product.name}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>

          <div className="form">
            <label className="form-label">
              Product Category <span className="is-required">*</span>
            </label>
            <DropdownWrapper
              setIsOpen={setPlaylistOpen}
              isOpen={playlistOpen}
              label={'Playlist'}
              getItemLabel={() => getCategory(tempSelectedCategory)}
              selectedItem={tempSelectedCategory ?? 'all'}
            >
              <CategoryDropdown
                categories={productCategory}
                setTempSelectedCategory={(id) => {
                  setTempSelectedCategory(id);
                }}
                handleSetPlaylist={onSelectCategoryHandler}
                tempSelectedCategory={tempSelectedCategory}
                handleNew={
                  filterAccess({
                    userData,
                    siteId,
                    param: 'category',
                    action: 'create',
                  })
                    ? handleNew
                    : null
                }
                modalOpen={playlistOpen}
              />
            </DropdownWrapper>
            {errors && errors.errors && errors.errors.categoryId && (
              <span className="error-message">
                {errors.errors.categoryId[0].msg}
              </span>
            )}
          </div>

          {(product.categoryId ||
            (product.categoryIds && product.categoryIds?.length > 0)) && (
            <div className="form">
              <label className="form-label">Sub Categories</label>
              <Select
                mode="multiple"
                optionLabelProp="label"
                value={product.subCategoryIds || []}
                filterOption={(input, opt) =>
                  (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={(e) => setProduct({ ...product, subCategoryIds: e })}
              >
                {productSubCategory
                  .filter(
                    (sub) =>
                      product.categoryIds?.includes(sub.categoryId) ||
                      product.categoryId === sub.categoryId
                  )
                  .map((subCat) => (
                    <Option
                      key={subCat._id}
                      value={subCat._id}
                      label={subCat.name}
                    >
                      <div className="option-tag">{subCat.name}</div>
                    </Option>
                  ))}
              </Select>

              {errors && errors.errors && errors.errors.location && (
                <span className="error-message">
                  {errors.errors.location[0].msg}
                </span>
              )}
            </div>
          )}

          <div className="form">
            <label className="form-label">Tags</label>
            <Select
              mode="multiple"
              optionLabelProp="label"
              value={product.tags || []}
              filterOption={(input, opt) =>
                (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={(e) => setProduct({ ...product, tags: e })}
            >
              {tagList.map((tag) => (
                <Option key={tag._id} value={tag._id} label={tag.name}>
                  <div className="option-tag">
                    <Avatar size="small" src={`${imgUrl}/tag/${tag.logo}`} />{' '}
                    {tag.name}
                  </div>
                </Option>
              ))}
            </Select>

            {errors && errors.errors && errors.errors.tags && (
              <span className="error-message">{errors.errors.tags[0].msg}</span>
            )}
          </div>

          <div className="form">
            <label className="form-label">Scheduling:</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <DatePicker
                allowClear
                style={{ width: '100%' }}
                placeholder="Start Date"
                format="DD/MM/YYYY"
                value={product.start ? dayjs(product.start) : null}
                onChange={(date) =>
                  handleChangeDate([
                    date,
                    product.end ? dayjs(product.end) : null,
                  ])
                }
              />
              <DatePicker
                allowClear
                style={{ width: '100%' }}
                placeholder="End Date"
                format="DD/MM/YYYY"
                value={product.end ? dayjs(product.end) : null}
                onChange={(date) =>
                  handleChangeDate([
                    product.start ? dayjs(product.start) : null,
                    date,
                  ])
                }
              />
            </div>
            {/* <Select
              onChange={(value) => handleChangeType(value)}
              value={type}
              defaultValue="all"
            >
              <Select.Option value="all">All Day</Select.Option>
              <Select.Option value="day">Day</Select.Option>
              <Select.Option value="date">Date</Select.Option>
            </Select> */}
          </div>

          <div className="form">
            <label className="form-label">
              Quantity <span className="is-required">*</span>
            </label>
            <Input
              placeholder="Product Quantity"
              className={`${
                errors && errors.errors && errors.errors.name ? 'has-error' : ''
              }`}
              name="quantity"
              value={product.quantity}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>
        </div>
        <div>
          <div className="form">
            <label className="form-label">Logo</label>
            {imagePreviewUrl ? (
              <div className="upload-image-preview">
                <Tooltip placement="top" title="Delete">
                  <button
                    type="button"
                    onClick={handleDeletePreviewImage}
                    className="btn-remove"
                  >
                    <i className="feather-x" />
                  </button>
                </Tooltip>
                <img
                  className="media-avatar"
                  src={imagePreviewUrl}
                  alt="User profile logo preview"
                />
              </div>
            ) : (
              <Upload
                accept="image/*"
                showUploadList={false}
                beforeUpload={onFileChangedHandler}
              >
                <div
                  onDragLeave={() => setIsDragged(false)}
                  onDragOver={() => setIsDragged(true)}
                  className={`upload-drag-and-drop ${
                    isDragged ? 'active' : ''
                  }`}
                >
                  <ExportIcon size={22} color="#C2C2C2" />
                  <p className="upload-title">
                    Drag or <span className="upload-highlight">Browse</span>
                  </p>
                  <p className="upload-subtitle">
                    File format supported: jpg, png (Up to 50MB){' '}
                  </p>
                </div>
              </Upload>
            )}
          </div>
          <div className="form">
            <label className="form-label">Description</label>
            <Input.TextArea
              rows={5}
              placeholder="POI Description"
              className={`${
                errors && errors.errors && errors.errors.description
                  ? 'has-error'
                  : ''
              }`}
              name="description"
              value={product.description}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.description && (
              <span className="error-message">
                {errors.errors.description[0].msg}
              </span>
            )}
          </div>
          <div className="form">
            <label className="form-label">Media Content 1</label>
            <Upload
              listType="picture-card"
              accept="image/*,video/mp4"
              beforeUpload={(file) =>
                onFileListChangedHandler({
                  file,
                  params: 'firstFileList',
                  setList: setFirstList,
                  list: firstList,
                })
              }
              onChange={({ fileList }) =>
                handleChange({ fileList, setPreview: setPreviewList })
              }
              onPreview={handlePreview}
              onRemove={(e) =>
                handleRemove({
                  e,
                  params: 'firstFileList',
                  productParams: 'firstMedias',
                  setList: setFirstList,
                  list: firstList,
                })
              }
              fileList={previewList}
            >
              <div>
                <i className="feather-upload" />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
          </div>
          <div className="form">
            <label className="form-label">Media Content 2</label>
            <Upload
              listType="picture-card"
              accept="image/*,video/mp4"
              beforeUpload={(file) =>
                onFileListChangedHandler({
                  file,
                  params: 'secondFileList',
                  setList: setSecondList,
                  list: secondList,
                })
              }
              onChange={({ fileList }) =>
                handleChange({ fileList, setPreview: setSecondPreviewList })
              }
              onPreview={handlePreview}
              onRemove={(e) =>
                handleRemove({
                  e,
                  params: 'secondFileList',
                  productParams: 'secondMedias',
                  setList: setSecondList,
                  list: secondList,
                })
              }
              fileList={secondPreviewList}
            >
              <div>
                <i className="feather-upload" />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
            <Modal
              visible={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
            >
              <img
                alt="product images"
                style={{ width: '100%' }}
                src={previewImage}
              />
            </Modal>
          </div>
          <div className="form">
            <label className="form-label">URL</label>
            <Input
              placeholder="POI URL"
              className={`${
                errors && errors.errors && errors.errors.url ? 'has-error' : ''
              }`}
              name="url"
              value={product.url}
              onChange={onChangeHandler}
            />
            {errors && errors.errors && errors.errors.url && (
              <span className="error-message">{errors.errors.url[0].msg}</span>
            )}
          </div>
        </div>
      </form>
      <div
        className="button-wrapper"
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <div>
          {loading ? (
            <button className="button-primary" disabled>
              Loading...
            </button>
          ) : (
            <button className="btn-primary" onClick={onSubmitHandler}>
              Submit
            </button>
          )}
          {/* <button className="button-secondary" onClick={handleReset}>
            Reset
          </button> */}
        </div>
      </div>
    </div>
  );
};

ProductForm.propTypes = {
  poiData: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
    priority: PropTypes.string,
    description: PropTypes.string,
    logo: PropTypes.string,
    opentime: PropTypes.string,
    url: PropTypes.string,
    category: PropTypes.string,
    siteId: PropTypes.string,
    tag: PropTypes.string,
    location: PropTypes.string,
    floor: PropTypes.string,
    modifiedAt: PropTypes.string,
    modifiedBy: PropTypes.string,
  }),
  action: PropTypes.func.isRequired,
};

export default ProductForm;
